import React from 'react'
import './news.css'
import img3 from '../../assets/biggallery/IMG_0873.JPG';

const News = () => {
  return (
    <section>
    <div className="news-container">
      <h1>uutiset</h1>
      <div className="news-box">
        <h5>20 December 2024</h5>
        <p>Hei, olemme avanneet ovemme talvikaudeksi 2024-25, tervetuloa. Tsekkaa tästä linkistä aukioloaikamme! <a href="/location" className="opencta"> Aukioloajat </a>
        </p>
        
          <img src={img3} alt="kerma-news" />
      </div>
    </div>
    </section>
  )
}

export default News